/**
 * Recipe article upsell behaviour.
 *
 * All listeners are delegated on document rather than bound per element: blog.js infinite-scrolls up
 * to two further .article-container elements onto the page, and inline scripts inside appended
 * markup never execute, so a page can hold several upsells that were never initialised.
 */
(function () {
  var ROOT = '[data-recipe-upsell]';

  function selectedOption(root) {
    var select = root.querySelector('.wb-recipe-upsell__select');
    if (!select) {
      return null;
    }
    return select.options[select.selectedIndex] || null;
  }

  function sync(root) {
    var opt = selectedOption(root);
    if (!opt) {
      return;
    }

    var btn = root.querySelector('.wb-recipe-upsell__atc');
    var priceEl = root.querySelector('.wb-recipe-upsell__price');
    var compareEl = root.querySelector('.wb-recipe-upsell__compare');
    var imgEl = root.querySelector('.wb-recipe-upsell__img');
    var available = opt.dataset.available === 'true';

    // innerHTML, not textContent: money_format carries HTML entities such as &euro;
    if (priceEl) {
      priceEl.innerHTML = opt.dataset.price || '';
    }
    if (compareEl) {
      compareEl.innerHTML = opt.dataset.comparePrice || '';
    }
    if (imgEl && opt.dataset.image) {
      imgEl.src = opt.dataset.image;
    }
    if (btn) {
      btn.dataset.variantId = opt.value;
      btn.disabled = !available;
      btn.textContent = available ? btn.dataset.labelAtc : btn.dataset.labelSoldout;
    }
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest ? event.target.closest('.wb-recipe-upsell__select') : null;
    if (!select) {
      return;
    }
    var root = select.closest(ROOT);
    if (root) {
      sync(root);
    }
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('.wb-recipe-upsell__atc') : null;
    if (!btn || btn.disabled || typeof window.orderAgain !== 'function') {
      return;
    }

    var root = btn.closest(ROOT);
    var imgEl = root ? root.querySelector('.wb-recipe-upsell__img') : null;
    var image = imgEl ? (imgEl.currentSrc || imgEl.src || imgEl.getAttribute('data-src') || '') : '';

    window.orderAgain(
      btn,
      parseInt(btn.dataset.variantId, 10),
      btn.dataset.productHandle,
      btn.dataset.productTitle,
      image
    );
  });

  /**
   * orderAgain's failure path dispatches wb:alert, whose only listeners are the screen-reader
   * announcer and an account-page-scoped jQuery handler — so a failed add is otherwise silent here.
   * Surface it through the existing cart notification (cart-messages, which ships inside the
   * sidecart) rather than adding a second banner system.
   */
  document.addEventListener('wb:alert', function (event) {
    var btn = event.detail && event.detail.element;
    if (!btn || !btn.closest || !btn.closest(ROOT)) {
      return;
    }
    if (typeof vueapp !== 'undefined' && vueapp) {
      vueapp.cartError = true;
    }
    if (typeof sidecart !== 'undefined' && sidecart) {
      sidecart._data.show = true;
    }
    btn.disabled = false;
  });
})();
